/**
 * Parses any id from a route parameter (typically a string from the router).
 *
 * Returns `undefined` when the value is not a non-empty string or when `Number(id)` is `NaN`.
 *
 * @param id - Raw route param, for example from `useRoute().params`.
 * @returns Result of `Number(id)` for valid numeric strings (including `"0"`), otherwise `undefined`.
 */
export function parseIdFromRoute(id: unknown): number | undefined {
    if (typeof id !== 'string' || !id) {
        return undefined;
    }

    const numId = Number(id);
    
    return Number.isNaN(numId) ? undefined : numId;
}
